import { parseISO } from "date-fns";
import { format, formatInTimeZone } from "date-fns-tz";

export const parseDate = (date: Date, dateFormat: string, timeZone?: string) => {
  return timeZone ? formatInTimeZone(date, timeZone, dateFormat) : format(parseISO(`${date}`), dateFormat);
};
